/**
 * @desc fulfilment
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.StockAdjustmentFulfilmentMasterRequestDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustment/fulfilment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
